import {
    faCog, faSignOutAlt, faMapMarkedAlt, faMapMarker, faMapMarkerAlt,
    faUsers, faUser, faEnvelope, faGlobe, faGlobeAmericas,
    faUserShield, faTimes, faQuestionCircle, faUserPlus,
    faPlus, faMinus, faEdit, faCheck, faLayerGroup, faMap, faCircle,
    faDatabase, faEllipsisH, faEllipsisV, faRadiation, faSave,
    faKey, faCamera, faImage, faUpload, faPrint, faArrowCircleDown,
    faArrowCircleUp, faArrowRight, faArrowLeft, faFilter, faStar, faWallet, faBirthdayCake, faPlusCircle, faMinusCircle,
    faStore, faBalanceScale, faFileAlt, faChevronLeft, faChevronRight, 
    faChevronUp, faChevronDown, faBookmark, faSync, faFolderOpen,
    faTrashAlt, faInfoCircle, faUserMd, faUserNurse, faShareAlt, faBriefcaseMedical, faBroom, faLock, faToggleOff, faToggleOn,
    faBoxOpen, faCopy, faBullseye, faFileDownload, faInfo, faHospital, faCalendarWeek, faFileImport, faBarcode, 
    faHouseMedical, faChartBar, faProjectDiagram, faList, faFileInvoice, faReceipt, faTemperatureLow, faTemperatureHigh,
    faEquals, faBug, faFlag, faScaleBalanced, faDollarSign, faTicket, faExternalLinkAlt, faBell, faTable, faEnvelopeOpen
} from '@fortawesome/free-solid-svg-icons'
import {
    faEyeSlash, faEye
} from '@fortawesome/free-regular-svg-icons'
import {
    facMenu, facMap, facFilter, facFunnel, facClock,
    facLayers, facBack, facChevron, facCheck,
    facPlus, facOpacity, facHidden, facEye,
    facInfo, facAverage, facMaximum, facMinimum, facMode,
    facEnvelope,
    facExplore,
    facUpgrade,
    facResources,
    facAbout,
    facTag,
    facLogin,
    facHeart,
    facUser,
    facUserRole,
    facOrg,
    facTrafficSource,
    facDashboard,
    facGlobe,
    facWallet,
    facCalendar,
    facEdit,
    facChange,
    facForbid,
    facLogout,
    facLock,
    facCreditCard,
    facSend,
    facPalette,
    facPlay,
    facReplay,
    facX,
    facPause,
    facBars,
    facInfo2,
    facStar,
    facEdu,
    facHouse,
    facCake,
    facUrban,
    facParliament,
    facBulb,
    facEthnicity,
    facPerson,
    facCityUrban,
    facRural,
    facWildire,
    facSnowstorm,
    facHailstorm,
    facTornado,
    facThunderstorm,
    facMale,
    facFemale,
    facTheaters,
    facMuseums,
    facFestivities,
    facArtGalleries,
    facOperas,
    facExtensionPlug,
    facDownload,
    facSearch,
    facRadius,
    facFemaleDoctor,
    facMaleDoctor,
} from '../style/custom-icons'
import { faGoogle, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

// import FontAwesome and custom icons one by one. This will reduce bundle size.
library.add(
    faCog, faBullseye, faFileDownload, faInfo, faFileImport,
    faSignOutAlt, faBarcode, faHouseMedical,
    faMapMarkedAlt, faChartBar, faProjectDiagram,
    faMapMarker, faList, faFileInvoice, faReceipt, faTable, faEnvelopeOpen,
    faMapMarkerAlt, faTemperatureLow, faTemperatureHigh,
    faUsers, faEquals, faBug, faFlag, faScaleBalanced,
    faUser, faDollarSign, faTicket, faExternalLinkAlt, faBell,
    faEnvelope,
    faGlobe,
    faGlobeAmericas,
    faUserShield,
    faTimes,
    faQuestionCircle,
    faUserPlus,
    faPlus,
    faMinus,
    faRadiation,
    faSave,
    faKey,
    faCamera,
    faImage,
    faUpload,
    faPrint,
    faFilter,
    faEdit,
    faCheck,
    faLayerGroup,
    faGoogle,
    faFacebook,
    faMap,
    faCircle,
    faDatabase,
    faEyeSlash,
    faEye,
    facEye, facAverage, facMaximum, facMinimum,
    facMenu, facMode,
    facMap,
    facFilter,
    facFunnel,
    facClock,
    facLayers,
    facBack,
    facChevron,
    facCheck,
    facPlus,
    facOpacity,
    facHidden,
    facInfo,
    facEnvelope,
    facExplore,
    facUpgrade,
    facResources,
    facAbout,
    facTag,
    facLogin,
    facHeart,
    facUser,
    facUserRole,
    facOrg,
    facTrafficSource,
    facDashboard,
    facGlobe,
    facWallet,
    facCalendar,
    facEdit,
    facChange,
    faEllipsisH,
    faEllipsisV,
    facForbid,
    facLogout,
    facLock,
    facCreditCard,
    facSend,
    facPalette,
    facPlay,
    facReplay,
    facX,
    facPause,
    facBars,
    facInfo2,
    facStar,
    facCake,
    facEdu,
    facUrban,
    facHouse,
    facParliament,
    facBulb,
    facEthnicity,
    facPerson,
    facCityUrban,
    facRural,
    facWildire,
    facSnowstorm,
    facHailstorm,
    facTornado,
    facThunderstorm,
    facMale,
    facFemale,
    facTheaters,
    facMuseums,
    facFestivities,
    facArtGalleries,
    facOperas,
    facExtensionPlug,
    facDownload,
    facSearch,
    faArrowCircleUp,
    faArrowCircleDown,
    faArrowRight,
    faArrowLeft,
    faStar,
    facRadius,
    facFemaleDoctor,
    facMaleDoctor,
    faWallet,
    faBirthdayCake,
    faPlusCircle,
    faMinusCircle,
    faStore,
    faBalanceScale,
    faFileAlt,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faBookmark,
    faSync,
    faFolderOpen,
    faTrashAlt,
    faInfoCircle,
    faUserMd,
    faUserNurse,
    faShareAlt,
    faBriefcaseMedical,
    faBroom,
    faLock,
    faToggleOff,
    faToggleOn,
    faBoxOpen,
    faCopy,
    faHospital,
    faCalendarWeek
)
